import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'gbc-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    imports: [NgClass]
})
export class AccordionComponent {
  @Input()
  toggleTitle: string;
  class: string;

  public toggled = false;

  onToggle(): void {
    this.toggled = !this.toggled;
  }
}
